import type { ReactNode } from 'react';

import { cn } from '@/shared/utils/cn';

export interface InlineAlertProps {
  children: ReactNode;
  /** Use `alert` for validation / submission errors. */
  role?: 'alert' | 'status';
  className?: string;
}

/**
 * Compact inline message for forms and dialogs (distinct from full-page {@link ErrorState}).
 */
export function InlineAlert({ children, role = 'alert', className }: InlineAlertProps) {
  return (
    <div
      role={role}
      className={cn(
        'rounded-lg border border-danger-subtle bg-danger-subtle/30 px-4 py-3 text-sm text-danger-strong',
        className,
      )}
    >
      {children}
    </div>
  );
}
